'use client'

import { createContext } from 'react'

import { ClientDataComponentIdentifier } from './types'

type ClientDataPortalContextType = {
  getElement: (id: ClientDataComponentIdentifier) => HTMLElement | null
  setElement: (id: ClientDataComponentIdentifier, element: HTMLElement | null) => void
  hiddenFallbackIds: ReadonlyArray<string>
  setHiddenFallbackIds: (callback: (ids: ReadonlyArray<string>) => ReadonlyArray<string>) => void
}

const ClientDataComponentContext = createContext<ClientDataPortalContextType | null>(null)

export default ClientDataComponentContext
